import React from 'react'

function NotFoundPage() {
  return (
    <div className='bg-[#212122] w-screen h-screen flex justify-center items-center'>
      <h1 className='text-white text-xl font-bold'>Page not found</h1>
    </div>
  )
}

export default NotFoundPage